<template>
<form v-on:submit.prevent="submit" class="search-form" :class="{'full-width':fullWidth}" v-on:click="$emit('click')">
	<field :params="{placeholder: placeholder}" v-model="searchTerms" ref="search" :focus="focus"></field>
	<i v-if="searchTerms != ''" class="fa fa-times icon-button" v-on:click="clearSearch"></i>
	<i v-else class="fa fa-search"></i>
</form>
</template>

<script>
import Field from "./Field"

export default {

	name: 'SearchBar',
	components: {
		Field
	},
	props: ["placeholder","fullWidth","maxWidth","value"],
	data() {
		return {
			searchTerms: "",
			showPlaceholder: true,
			focus: false
		}
	},
	watch: {
		searchTerms() {
			this.$emit("termsChange",this.searchTerms)
			this.$emit("input",this.searchTerms)
		},
		value() {
			this.searchTerms = this.value
		}
	},
	methods: {
		submit() {
			this.$emit("submit",this.searchTerms)
		},
		clearSearch() {
			this.searchTerms = ""
			this.$emit("clearSearch",this.searchTerms)
		},
	},
	created() {
		if (this.value)
			this.searchTerms = this.value
	}
}

</script>

<style type="text/css" scoped>
	form {
		max-width: 300px;
		display: inline-block;
		padding: 0;
		margin: 0;
		margin-right: 10px;
		position: relative;
		transition: max-width 0.5s;
	}

	form.full-width {
		max-width: none;
		display: block;
		margin: 0;
	}

	.icon-button {
		position: absolute;
		right: 8px;
		top: 8px;
		color: #a0a0a0;
	}

	.fa-search {
		position: absolute;
		right: 10px;
		top: 10px;
		color: #a0a0a0;
	}

	/*@media (max-width: 400px) {
		form {
			max-width: 170px;
		}
	}*/
</style>